import { h } from 'preact'
import Icon from '../../assets'

interface CalendarMonthProps {
  month: number
  year: number
  onChangeMonth: (offset: 1 | -1) => void
}

const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']

export const CalendarMonth = ({ month, year, onChangeMonth }: CalendarMonthProps) => (
  <div className='a-calendar-month'>
    <span onClick={() => onChangeMonth(-1)}><Icon icon='chevronLeft' /></span>
    {`${months[month]} ${year}`}
    <span onClick={() => onChangeMonth(1)}><Icon icon='chevronRight' /></span>
  </div>
)
